import React from 'react';

export const Header = (props) => {
  return (
    <header id='header'>
      <div className='container'>
        <p>
            For RO Repair in Delhi-NCR &amp; Home Visit Charge @299 Only. Best RO Repair Center in Delhi-NCR. Trained Technicians.
        </p>
      </div>
    </header>
  )
}
